var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useRef, useState, } from "react";
import styled from "styled-components";
import { useWeb3Wallet } from "shared/lib/hooks/useWeb3Wallet";
import { setTimeout } from "timers";
import Davatar from "@davatar/react";
import sizes from "shared/lib/designSystem/sizes";
import { Title, BaseButton } from "shared/lib/designSystem";
import { addConnectEvent } from "shared/lib/utils/analytics";
import colors from "shared/lib/designSystem/colors";
import theme from "shared/lib/designSystem/theme";
import MobileOverlayMenu from "shared/lib/components/Common/MobileOverlayMenu";
import MenuButton from "shared/lib/components/Common/MenuButton";
import { copyTextToClipboard } from "shared/lib/utils/text";
import useOutsideAlerter from "shared/lib/hooks/useOutsideAlerter";
import { ActionButton } from "shared/lib/components/Common/buttons";
import ActionModal from "../Vault/VaultActionsForm/Modal/ActionModal";
import useConnectWalletModal from "shared/lib/hooks/useConnectWalletModal";
import useENSSearch from "shared/lib/hooks/useENSSearch";
import ButtonArrow from "shared/lib/components/Common/ButtonArrow";
import DesktopFloatingMenu from "shared/lib/components/Menu/DesktopFloatingMenu";
import { Chains, getExplorerName, getAssets, getExplorerURI, VaultList, isEarnVault, } from "shared/lib/constants/constants";
import { CHAINID } from "shared/lib/utils/env";
import { getVaultColor } from "shared/lib/utils/vault";
import { truncateAddress } from "shared/lib/utils/address";
import { useVaultData } from "shared/lib/hooks/web3DataContext";
import useVaultAccounts from "shared/lib/hooks/useVaultAccounts";
import { isPracticallyZero } from "shared/lib/utils/math";
import { getAssetDecimals } from "shared/lib/utils/asset";
import YourPosition from "shared/lib/components/Vault/YourPosition";
import AirdropButton from "../Airdrop/AirdropButton";
import AirdropModal from "../Airdrop/AirdropModal";
import Indicator from "shared/lib/components/Indicator/Indicator";
import { useChain } from "shared/lib/hooks/chainContext";
import { useAirtableVIPData } from "shared/lib/hooks/useAirtableVIPData";
import { VIPLogo } from "shared/lib/assets/icons/logo";
import VIPButton from "../VIP/VIPButton";
import VIPModal from "../VIP/VIPModal";
var walletButtonMarginLeft = 5;
var walletButtonWidth = 55;
var investButtonWidth = 30;
var investButtonMarginLeft = 100 - walletButtonMarginLeft * 2 - walletButtonWidth - investButtonWidth;
var AccountStatusContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex-wrap: wrap;\n  flex-direction: column;\n\n  ", "\n"], ["\n  flex-wrap: wrap;\n  flex-direction: column;\n\n  ", "\n"])), function (props) {
    switch (props.variant) {
        case "mobile":
            return "\n          display: none;\n\n          @media (max-width: " + sizes.md + "px) {\n            display: flex;\n            width: 100%;\n          }\n        ";
        case "desktop":
            return "\n          display: flex;\n        ";
    }
});
var WalletContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  justify-content: center;\n  align-items: center;\n\n  ", "\n"], ["\n  justify-content: center;\n  align-items: center;\n\n  ", "\n"])), function (props) {
    switch (props.variant) {
        case "desktop":
            return "\n        display: flex;\n        padding-right: 40px;\n        z-index: 1000;\n        position: relative;\n\n        @media (max-width: " + sizes.md + "px) {\n          display: none;\n        }\n        ";
        case "mobile":
            return "\n          display: none;\n\n          @media (max-width: " + sizes.md + "px) {\n            display: flex;\n            align-items: unset;\n            padding-top: 16px;\n            width: 100%;\n          }\n        ";
    }
});
var WalletButton = styled(BaseButton)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background-color: ", ";\n  align-items: center;\n  height: 48px;\n\n  &:hover {\n    opacity: ", ";\n  }\n\n  ", "\n"], ["\n  background-color: ", ";\n  align-items: center;\n  height: 48px;\n\n  &:hover {\n    opacity: ", ";\n  }\n\n  ", "\n"])), function (props) {
    return props.connected ? colors.background.two : colors.green + "14";
}, theme.hover.opacity, function (props) {
    switch (props.variant) {
        case "mobile":
            return "\n        height: 48px;\n        justify-content: center;\n        padding: 14px 16px;\n        width: " + (props.showInvestButton ? walletButtonWidth + "%" : "90%") + ";\n      ";
        case "desktop":
            return "";
    }
});
var WalletButtonText = styled(Title)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-size: 14px;\n  line-height: 20px;\n\n  @media (max-width: ", "px) {\n    font-size: 16px;\n  }\n\n  @media (max-width: 350px) {\n    font-size: 13px;\n  }\n\n  ", "\n"], ["\n  font-size: 14px;\n  line-height: 20px;\n\n  @media (max-width: ", "px) {\n    font-size: 16px;\n  }\n\n  @media (max-width: 350px) {\n    font-size: 13px;\n  }\n\n  ", "\n"])), sizes.md, function (props) {
    if (props.connected)
        return null;
    return "color: " + colors.green;
});
var Avatar = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin-right: 8px;\n  display: flex;\n  align-items: center;\n"], ["\n  margin-right: 8px;\n  display: flex;\n  align-items: center;\n"])));
var InvestButton = styled(ActionButton)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  margin-left: ", "%;\n  width: ", "%;\n  height: 48px;\n  justify-content: center;\n  border-radius: ", ";\n"], ["\n  margin-left: ", "%;\n  width: ", "%;\n  height: 48px;\n  justify-content: center;\n  border-radius: ", ";\n"])), investButtonMarginLeft, investButtonWidth, theme.border.radius);
var WalletMobileOverlayMenu = styled(MobileOverlayMenu)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  display: none;\n\n  ", "\n"], ["\n  display: none;\n\n  ", "\n"])), function (props) {
    switch (props.variant) {
        case "mobile":
            return "\n          @media (max-width: " + sizes.md + "px) {\n            display: flex;\n            z-index: " + (props.isMenuOpen ? 50 : -1) + ";\n          }\n        ";
        case "desktop":
            return "";
    }
});
var MenuItem = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  padding: 8px 16px;\n  padding-right: 38px;\n  opacity: 1;\n  display: flex;\n  align-items: center;\n\n  &:first-child {\n    padding-top: 16px;\n  }\n\n  &:last-child {\n    padding-bottom: 16px;\n  }\n\n  &:hover {\n    span {\n      color: ", ";\n    }\n  }\n\n  @media (max-width: ", "px) {\n    margin: unset;\n    && {\n      padding: 28px;\n    }\n  }\n"], ["\n  padding: 8px 16px;\n  padding-right: 38px;\n  opacity: 1;\n  display: flex;\n  align-items: center;\n\n  &:first-child {\n    padding-top: 16px;\n  }\n\n  &:last-child {\n    padding-bottom: 16px;\n  }\n\n  &:hover {\n    span {\n      color: ", ";\n    }\n  }\n\n  @media (max-width: ", "px) {\n    margin: unset;\n    && {\n      padding: 28px;\n    }\n  }\n"])), colors.primaryText, sizes.md);
var MenuItemText = styled(Title)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  color: ", "A3;\n  white-space: nowrap;\n  font-size: 14px;\n  line-height: 20px;\n\n  @media (max-width: ", "px) {\n    font-size: 24px;\n  }\n"], ["\n  color: ", "A3;\n  white-space: nowrap;\n  font-size: 14px;\n  line-height: 20px;\n\n  @media (max-width: ", "px) {\n    font-size: 24px;\n  }\n"])), colors.primaryText, sizes.md);
var WalletCopyIcon = styled.i(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  color: white;\n  margin-left: 8px;\n  transition: 0.1s all ease-out;\n\n  ", "\n"], ["\n  color: white;\n  margin-left: 8px;\n  transition: 0.1s all ease-out;\n\n  ", "\n"])), function (props) {
    switch (props.state) {
        case "visible":
            return "\n          opacity: 1;\n        ";
        case "hiding":
            return "\n          opacity: 0;\n        ";
        case "hidden":
            return "\n          visibility: hidden;\n          height: 0;\n          width: 0;\n          opacity: 0;\n        ";
    }
});
var MenuCloseItem = styled(MenuItem)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  position: absolute;\n  bottom: 50px;\n  left: 0;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n"], ["\n  position: absolute;\n  bottom: 50px;\n  left: 0;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n"])));
var AirdropMenuItem = styled(MenuItem)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  padding: 4px 8px;\n"], ["\n  padding: 4px 8px;\n"])));
var AccountStatus = function (_a) {
    var vault = _a.vault, variant = _a.variant, showVaultPositionHook = _a.showVaultPositionHook, _b = _a.showAirdropButton, showAirdropButton = _b === void 0 ? true : _b;
    var _c = useChain(), chain = _c[0], setChain = _c[1];
    var _d = useWeb3Wallet(), deactivate = _d.deactivate, ethereumProvider = _d.ethereumProvider, active = _d.active, account = _d.account, chainId = _d.chainId, isLedgerLive = _d.isLedgerLive;
    var _e = useConnectWalletModal(), setShowConnectModal = _e[1];
    var _f = useState(false), showActionModal = _f[0], setShowActionModal = _f[1];
    var _g = useState(false), showAirdropModal = _g[0], setShowAirdropModal = _g[1];
    var _h = useState(false), showVIPModal = _h[0], setShowVIPModal = _h[1];
    var _j = useState(false), isMenuOpen = _j[0], setIsMenuOpen = _j[1];
    var _k = useState("hidden"), copyState = _k[0], setCopyState = _k[1];
    var ensData = useENSSearch(account || "").data;
    var _l = useVaultData((vault === null || vault === void 0 ? void 0 : vault.vaultOption) || VaultList[0]), status = _l.status, vaultLimit = _l.vaultLimit;
    var isVIPAddress = useAirtableVIPData().isVIPAddress;
    var _m = useVaultAccounts("v1"), v1VaultAccounts = _m.vaultAccounts, v1VaultAccountsLoading = _m.loading;
    // Track clicked area outside of desktop menu
    var desktopMenuRef = useRef(null);
    useOutsideAlerter(desktopMenuRef, function () {
        if (variant === "desktop" && isMenuOpen)
            onCloseMenu();
    });
    useEffect(function () {
        if (ethereumProvider && account) {
            addConnectEvent("header", account);
        }
    }, [ethereumProvider, account]);
    useEffect(function () {
        var timer;
        switch (copyState) {
            case "visible":
                timer = setTimeout(function () {
                    setCopyState("hiding");
                }, 800);
                break;
            case "hiding":
                timer = setTimeout(function () {
                    setCopyState("hidden");
                }, 200);
        }
        if (timer)
            clearTimeout(timer);
    }, [copyState]);
    var onToggleMenu = useCallback(function () {
        setIsMenuOpen(function (open) { return !open; });
    }, []);
    var handleButtonClick = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (active) {
                onToggleMenu();
                return [2 /*return*/];
            }
            setShowConnectModal(true);
            return [2 /*return*/];
        });
    }); }, [active, onToggleMenu, setShowConnectModal]);
    var onCloseMenu = useCallback(function () {
        setIsMenuOpen(false);
    }, []);
    var onShowAirdropModal = useCallback(function () {
        setIsMenuOpen(false);
        setShowAirdropModal(true);
    }, []);
    var onShowVIPModal = useCallback(function () {
        setIsMenuOpen(false);
        setShowVIPModal(true);
    }, []);
    var handleChangeWallet = useCallback(function () {
        setShowConnectModal(true);
        onCloseMenu();
    }, [onCloseMenu, setShowConnectModal]);
    var handleCopyAddress = useCallback(function () {
        if (account) {
            copyTextToClipboard(account);
            setCopyState("visible");
        }
    }, [account]);
    var handleOpenEtherscan = useCallback(function () {
        if (account && chain) {
            window.open(getExplorerURI(chain) + "/address/" + account);
        }
    }, [account, chain]);
    var handleDisconnect = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, deactivate()];
                case 1:
                    _a.sent();
                    setChain(Chains.NotSelected);
                    onCloseMenu();
                    return [2 /*return*/];
            }
        });
    }); }, [deactivate, setChain, onCloseMenu]);
    var onCloseActionsModal = useCallback(function () {
        setShowActionModal(false);
    }, [setShowActionModal]);
    var handleInvestButtonClick = function () {
        setShowActionModal(true);
    };
    var renderButtonContent = function () {
        return active && account ? (_jsxs(_Fragment, { children: [chainId ? (_jsx(Avatar, { children: isVIPAddress ? (_jsx(VIPLogo, { width: 16, height: 16 }, void 0)) : (_jsx(Davatar, { address: account, size: 16 }, void 0)) }, void 0)) : (_jsx(Indicator, { connected: active }, void 0)), _jsxs(WalletButtonText, __assign({ connected: active }, { children: [(ensData === null || ensData === void 0 ? void 0 : ensData.name) || truncateAddress(account), " ", _jsx(ButtonArrow, { isOpen: isMenuOpen }, void 0)] }), void 0)] }, void 0)) : (_jsx(WalletButtonText, __assign({ connected: active }, { children: "CONNECT WALLET" }), void 0));
    };
    var renderMenuItem = function (title, onClick, extra) {
        return (_jsxs(MenuItem, __assign({ onClick: onClick, role: "button" }, { children: [_jsx(MenuItemText, { children: title }, void 0), extra] }), void 0));
    };
    var renderCopiedButton = function () {
        return _jsx(WalletCopyIcon, { className: "far fa-clone", state: copyState }, void 0);
    };
    var formModal = useMemo(function () {
        return vault ? (_jsx(ActionModal, { vault: vault, variant: "mobile", show: showActionModal, onClose: onCloseActionsModal }, void 0)) : null;
    }, [vault, showActionModal, onCloseActionsModal]);
    return (_jsxs(AccountStatusContainer, __assign({ variant: variant }, { children: [vault && !isEarnVault(vault.vaultOption) && (_jsx(YourPosition, { vault: vault, variant: "mobile", onShowHook: showVaultPositionHook }, void 0)), _jsxs(WalletContainer, __assign({ variant: variant, ref: desktopMenuRef }, { children: [_jsx(WalletButton, __assign({ variant: variant, showInvestButton: vault && !isEarnVault(vault.vaultOption), connected: active, role: "button", onClick: handleButtonClick }, { children: renderButtonContent() }), void 0), vault && !isEarnVault(vault.vaultOption) && (_jsx(InvestButton, __assign({ onClick: handleInvestButtonClick, color: getVaultColor(vault.vaultOption) }, { children: (status !== "loading" &&
                            vault.vaultVersion === "v1" &&
                            vaultLimit.isZero()) ||
                            (!v1VaultAccountsLoading &&
                                vault.vaultVersion === "v2" &&
                                v1VaultAccounts[vault.vaultOption] &&
                                !isPracticallyZero(v1VaultAccounts[vault.vaultOption].totalBalance, getAssetDecimals(getAssets(vault.vaultOption))))
                            ? "Migrate"
                            : "Invest" }), void 0)), _jsxs(DesktopFloatingMenu, __assign({ isOpen: isMenuOpen, containerStyle: { right: 40 } }, { children: [renderMenuItem(copyState === "hidden" ? "COPY ADDRESS" : "ADDRESS COPIED", handleCopyAddress, renderCopiedButton()), chain !== Chains.NotSelected &&
                                renderMenuItem("OPEN IN " + getExplorerName(chain), handleOpenEtherscan), !isLedgerLive && renderMenuItem("DISCONNECT", handleDisconnect), chainId === CHAINID.ETH_MAINNET && showAirdropButton && (_jsx(AirdropMenuItem, __assign({ role: "button" }, { children: _jsx(AirdropButton, { onClick: onShowAirdropModal }, void 0) }), void 0)), isVIPAddress && (_jsx(AirdropMenuItem, __assign({ role: "button" }, { children: _jsx(VIPButton, { onClick: onShowVIPModal }, void 0) }), void 0))] }), void 0)] }), void 0), _jsxs(WalletMobileOverlayMenu, __assign({ className: "flex-column align-items-center justify-content-center", isMenuOpen: isMenuOpen, onClick: onCloseMenu, variant: variant, mountRoot: "div#root", overflowOnOpen: false }, { children: [renderMenuItem("CHANGE WALLET", handleChangeWallet), renderMenuItem(copyState === "hidden" ? "COPY ADDRESS" : "ADDRESS COPIED", handleCopyAddress, renderCopiedButton()), chain !== Chains.NotSelected &&
                        renderMenuItem("OPEN IN " + getExplorerName(chain), handleOpenEtherscan), !isLedgerLive && renderMenuItem("DISCONNECT", handleDisconnect), _jsx(MenuCloseItem, __assign({ role: "button", onClick: onCloseMenu }, { children: _jsx(MenuButton, { isOpen: true, onToggle: onCloseMenu }, void 0) }), void 0), chainId === CHAINID.ETH_MAINNET && showAirdropButton && (_jsx(AirdropMenuItem, __assign({ role: "button" }, { children: _jsx(AirdropButton, { onClick: onShowAirdropModal }, void 0) }), void 0))] }), void 0), formModal, _jsx(AirdropModal, { show: showAirdropModal, onClose: function () {
                    setShowAirdropModal(false);
                } }, void 0), _jsx(VIPModal, { show: showVIPModal, onClose: function () {
                    setShowVIPModal(false);
                } }, void 0)] }), void 0));
};
export default AccountStatus;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;
//# sourceMappingURL=AccountStatus.js.map